import {
  createContext,
  Dispatch,
  useMemo,
  useState,
  useContext,
} from 'react';

// Implementation of Context Provider example: https://devtrium.com/posts/how-use-react-context-pro

interface EntityNameForNavProviderI {
  entityName: string;
  setEntityName: Dispatch<any>;
}

const EntityNameContext = createContext<EntityNameForNavProviderI | null>(null);

/* === use === */
const useEntityNameForNav = () => {
  const entityNameContext = useContext(EntityNameContext);

  return {
    entityNameForNav: entityNameContext?.entityName as string,
    setEntityNameForNav: entityNameContext?.setEntityName as Dispatch<any>,
  };
};

interface EntityNameForNavProviderProps {
  children: any | Element[];
}
/* === provider === */
const EntityNameForNavProvider = ({ children }: EntityNameForNavProviderProps) => {
  const [entityName, setEntityName] = useState('');

  const contextValue = useMemo<EntityNameForNavProviderI>(() => ({
    entityName,
    setEntityName,
  }), [entityName]);

  return (
    <EntityNameContext.Provider value={contextValue}>
      {children}
    </EntityNameContext.Provider>
  );
};

export { EntityNameForNavProvider, useEntityNameForNav };
